export const SCORM_MESSAGE_KINDS = {
  INIT: 'libertify-scorm:init',
  SET_LOCATION: 'libertify-scorm:set-location',
  COMPLETE: 'libertify-scorm:complete',
  FLUSH: 'libertify-scorm:flush',
  RESUME_RESPONSE: 'libertify-scorm:resume-response',
} as const;

export type ScormMessageKind = (typeof SCORM_MESSAGE_KINDS)[keyof typeof SCORM_MESSAGE_KINDS];

export type ScormInitMessage = {
  kind: typeof SCORM_MESSAGE_KINDS.INIT;
};

export type ScormSetLocationMessage = {
  kind: typeof SCORM_MESSAGE_KINDS.SET_LOCATION;
  lessonLocation: number;
  /** Watched-coverage percentage (0–100), reported as cmi.core.score.raw. */
  score?: number;
  /** Serialized watch progress (see watchProgress.ts), stored in cmi.suspend_data. */
  suspendData?: string;
};

export type ScormCompleteMessage = {
  kind: typeof SCORM_MESSAGE_KINDS.COMPLETE;
};

export type ScormFlushMessage = {
  kind: typeof SCORM_MESSAGE_KINDS.FLUSH;
};

export type ScormResumeResponseMessage = {
  kind: typeof SCORM_MESSAGE_KINDS.RESUME_RESPONSE;
  lessonLocation: number;
  /** Raw cmi.suspend_data from the LMS ('' when none was stored). */
  suspendData?: string;
  /** True when the LMS already reports lesson_status=completed. */
  completed?: boolean;
};

export type ScormPlayerToShim =
  | ScormInitMessage
  | ScormSetLocationMessage
  | ScormCompleteMessage
  | ScormFlushMessage;
